import { shiftService } from "../../_services"
import {SHIFT_ACTION_TYPES, COMMON_ACTION_TYPES} from "../../_constants";
import {exceptionHandler} from "../../_helpers";

const getAllShiftList = (onSuccess, onError) => {
    return action => {
        action({type: SHIFT_ACTION_TYPES.GET_SHIFT_LIST + COMMON_ACTION_TYPES.REQUEST})
            shiftService.getAllShiftList()
                .then( res => {
                    action({type: SHIFT_ACTION_TYPES.GET_SHIFT_LIST + COMMON_ACTION_TYPES.SUCCESS, data: res.data})
                    onSuccess(res.data);
                })
                .catch( error => {
                    action({type: SHIFT_ACTION_TYPES.GET_SHIFT_LIST + COMMON_ACTION_TYPES.ERROR, data: error})
                    onError(exceptionHandler.catchError(error.response))
                })
    }
}

export const shiftActions = {
    getAllShiftList
};
